// INITIAL FILE RUN BY NODE
// The index.js file is the entry point of a React application.
import { StoreProvider } from "easy-peasy"
import { createRoot } from "react-dom/client"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import App from "./App"
import { AuthProvider } from "./context/AuthProvider"
import "./css/index.css"
import store from "./store"

// Find the root element in index.html
// Create a React root
const root = createRoot(document.getElementById("root"))

root.render(
	//  StrictMode causes double rendering during testing so turn it off
	//   <React.StrictMode>
	<AuthProvider>
		<StoreProvider store={store}>
			<Router>
				<Routes>
					{/* Catch-all route used to match any URL path */}
					<Route path="/*" element={<App />} />
				</Routes>
			</Router>
		</StoreProvider>
	</AuthProvider>,
	//   </React.StrictMode>
)
